import React from "react";
import BaseEmailComponent from "../BaseEmailComponent";
import { Form } from "react-bootstrap";

const HeadingDescription = ({ id, data, onUpdate, styleSettings, variant = "default" }) => {
  // Edit UI with forms for title and description
  const renderEditUI = ({ title, setTitle, description, setDescription, handleSaveChanges, styleSettings }) => {
    // Function to save all changes at once
    const saveAllChanges = () => {
      handleSaveChanges(title, description);
    };

    return (
      <div className="p-3 rounded" style={{ backgroundColor: 'white' }}>
        <Form.Group className="mb-3">
          <Form.Label><strong>Heading</strong></Form.Label>
          <Form.Control
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onBlur={saveAllChanges}
            placeholder="Enter Heading"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label><strong>Description</strong></Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            onBlur={saveAllChanges}
            placeholder="Enter Description"
          />
        </Form.Group>
      </div>
    );
  };

  // View UI for display mode with different variants
  const renderViewUI = ({ title, description, styleSettings }) => {
    const { primaryColor, secondaryColor, fontFamily } = styleSettings || {};
    // Extract features to prevent "features is not defined" error
    const features = data?.features || [];
    
    // Different styling options based on variant
    const getVariantStyles = () => {
      switch(variant) {
        case "centered":
          return {
            titleAlign: "center",
            descAlign: "center",
            titleSize: "28px",
            titleColor: secondaryColor,
            descColor: primaryColor
          };
        case "large":
          return {
            titleAlign: "left",
            descAlign: "left",
            titleSize: "32px",
            titleColor: secondaryColor,
            descColor: primaryColor
          };
        case "compact":
          return {
            titleAlign: "left",
            descAlign: "left",
            titleSize: "22px",
            titleColor: primaryColor,
            descColor: "#666666"
          };
        default:
          return {
            titleAlign: "left",
            descAlign: "left",
            titleSize: "24px",
            titleColor: secondaryColor,
            descColor: primaryColor
          };
      }
    };
    
    const styles = getVariantStyles();

    return (
      <div className="py-3">
        <h2 style={{ 
          fontSize: styles.titleSize, 
          marginBottom: "16px",
          color: styles.titleColor || "#a1894c",
          fontFamily,
          textAlign: styles.titleAlign,
          fontWeight: "bold"
        }}>
          {title}
        </h2>
        <div className="description-text" style={{ 
          fontFamily,
          color: styles.descColor || "#333333",
          textAlign: styles.descAlign,
          lineHeight: "1.6",
          fontSize: "16px"
        }}>
          {description}
        </div>
      </div>
    );
  };

  return (
    <BaseEmailComponent
      id={id}
      data={data}
      onUpdate={onUpdate}
      componentName="Heading & Description"
      styleSettings={styleSettings}
      editUI={renderEditUI}
      viewUI={renderViewUI}
    />
  );
};

export default HeadingDescription; 